import { useCallback, useState } from "react";
import { get } from "services";
import alerts from "utils/alerts";

export const useTalentos = (user) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(true);
  const [talentos, setTalentos] = useState([]);

  const fetchPersonaTalentos = useCallback(async () => {
    const res = await get(`PersonaTalento/Persona/${user.persona.id}`);
    user.persona.personaTalentos = res.data;
    if (
      user.persona.personaTalentos &&
      user.persona.personaTalentos.length > 0 &&
      user.persona.personaTalentos.filter((x) => x.estado != 0).length > 0
    ) {
      setShowDetail(true);
    } else {
      setShowDetail(false);
    }
  });

  const fetchTalentos = useCallback(async () => {
    const res = await get("Talento");
    setTalentos(res.data);
  });

  const fetchTalentosModuleData = useCallback(async () => {
    try {
      setIsLoading(true);
      await fetchPersonaTalentos();
      await fetchTalentos();
    } catch (err) {
      alerts.operationFail();
    } finally {
      setIsLoading(false);
    }
  });

  return {
    isLoading,
    showDetail,
    setShowDetail,
    talentos,
    fetchTalentosModuleData,
  };
};
